/**
 * CommandPaletteHint (P2.1-S4) — Topbar entry point cho Command Palette.
 *
 * Desktop: button "🔍 Tìm... ⌘K" pill style — vừa visible vừa shortcut hint.
 * Mobile (< sm): chỉ icon button.
 */
import { Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useCommandPaletteStore } from "@/stores/commandPalette";

export function CommandPaletteHint(): JSX.Element {
  const openPalette = useCommandPaletteStore((s) => s.openPalette);

  // Detect platform để show ⌘ hoặc Ctrl
  const isMac =
    typeof navigator !== "undefined" &&
    /Mac|iPhone|iPad|iPod/i.test(navigator.platform);
  const shortcut = isMac ? "⌘K" : "Ctrl K";

  return (
    <>
      {/* Desktop: pill button hiển thị label + shortcut */}
      <button
        type="button"
        onClick={openPalette}
        className="hidden md:inline-flex items-center gap-2 h-8 px-2.5 rounded-md border border-input bg-background text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors min-w-[200px]"
        aria-label="Mở command palette"
      >
        <Search className="size-3.5" />
        <span className="text-xs flex-1 text-left">Tìm hoặc nhảy tới...</span>
        <kbd className="text-[10px] border rounded px-1.5 py-0.5 bg-muted/40">
          {shortcut}
        </kbd>
      </button>

      {/* Mobile: icon-only */}
      <Button
        variant="ghost"
        size="icon"
        onClick={openPalette}
        aria-label="Mở command palette"
        className="md:hidden"
      >
        <Search className="size-4" />
      </Button>
    </>
  );
}
